<template>
  <div class="wrapper">
    <div class="wrapper_main" v-if="showPage">
        <div class="headerBox">
          <div class="cardLeft">
            <div class="clockBox">
              <img class="clockIcon" src="../../assets/images/icon_order_unpaid.png">
              <p class="clockText" v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && orderInfo.refundSucTime">退款成功</p>
              <p class="clockText" v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && !orderInfo.refundSucTime && orderInfo.refundUpdTime">退款处理中</p>
              <p class="clockText" v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && !orderInfo.refundUpdTime">退款申请已提交</p>
              <p class="clockText" v-if="!orderInfo.refundStatus && orderInfo.refundStatus !== 0">{{status | statusText}}</p>
              <p class="clockText" v-if="orderInfo.isFree === 3">(线下支付)</p>
            </div>
            <p class="statusText" v-if="status == '0'">剩余时间 {{lastPayTime}}</p>
            <p class="statusText" v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && orderInfo.refundSucTime">{{orderInfo.refundSucTime}}</p>
            <p class="statusText" v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && !orderInfo.refundSucTime && orderInfo.refundUpdTime">{{orderInfo.refundUpdTime}}</p>
            <p class="statusText" v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && !orderInfo.refundUpdTime">{{orderInfo.refundTime}}</p>
            <p class="statusText" v-if="status != '0' && !orderInfo.refundStatus && orderInfo.refundStatus !== 0">{{status | statusPrompt}}</p>
          </div>
          <img class="order_img" src="../../assets/images/img_order_detail_meeting.png">
        </div>
        <div class="refundBox" v-if="orderInfo.refundStatus || orderInfo.refundStatus === 0">
          <span class="refundText">退款进度</span>
          <div class="refundMainBox">
            <div class="refundMainLeft">
              <div class="circle active_color"></div>
              <div :class="[orderInfo.refundUpdTime?'active_color':'default_color', 'upright']"></div>
              <div :class="[orderInfo.refundUpdTime?'active_color':'default_color', 'circle']"></div>
              <div :class="[orderInfo.refundSucTime?'active_color':'default_color', 'upright']"></div>
              <div :class="[orderInfo.refundSucTime?'active_color':'default_color', 'circle']"></div>
            </div>
            <div class="refundMainRight refundMainRight_succ">
              <span class="refundMainText">退款申请已提交</span>
              <span :class="[orderInfo.refundUpdTime?'refund_active':'refund_default', 'refundMainText']">退款处理中</span>
              <span :class="[orderInfo.refundSucTime?'refund_active':'refund_default', 'refundMainText']">退款成功</span>
            </div>
          </div>
        </div>
        <!-- 开门密码 -->
      <div class="mainCard" v-if="orderInfo.isLock == 1 && (status == '2' && !orderInfo.refundStatus && orderInfo.refundStatus !== 0)">
        <span class="password_text">开门密码</span>
        <div class="password_main">
          <span class="password_item" v-for="(item,index) in orderInfo.pwdText" :key="index">{{item}}</span>
        </div>
      </div>
      <div class="mainCard">
        <!--  -->
        <div class="QRCodeCard" v-if="doorLockId &&  orderInfo.isLock != 1 && status == '2' && !orderInfo.refundStatus && orderInfo.refundStatus !== 0" >
          <span class="QRCodeTitle">会议室门禁</span>
          <div class="QRCodeOrderNo_tips">刷码建议距离10cm左右</div>
          <!-- <img :src="QRCode" class="QRCode"> -->
          <div class="QRCode" v-if="!refunding" ref="qrCodeUrl"></div>
          <span class="QRCodeOrderNo">{{orderInfo.orderNo}}</span>
          <div class="QRCode_tips_div">
             <img class="QRCode_tips_icon" src="../../assets/images/meeting_icon_hint.png"/>
             <span class="QRCode_tips_span">此二维码用于公共区域闸机通行和会议室开门，具体使用规则视项目硬件条件略有不同，敬请谅解！</span>
          </div>

        </div>
      </div>
        <div class="click_item" @click="goMeetingDetail(orderInfo.meetingRoomId)">
          <img class="click_image" :src="orderInfo.meetingRoomImages">
          <div class="click_info">
            <p class="click_title ellipsis">{{orderInfo.meetingRoomName}}</p>
            <p class="click_time click_desc ellipsis">{{orderInfo.address}}</p>
            <p class="click_address click_desc ellipsis">面积:{{orderInfo.area}}㎡</p>
            <p class="click_address click_desc ellipsis">座位:{{orderInfo.meetingRoomNum}}人</p>
          </div>
        </div>
        <!-- <div class="orderCard">
          <p class="orderTitle">报名信息</p>
          <div class="orderNubBox" v-for="(item,index) in activeReg" :key="index">
            <span class="orderNubTitle">{{item.regDicName}}</span>
            <span class="orderNub">{{item.regDicValue}}</span>
          </div>
        </div> -->
        <div class="orderCard">
          <p class="orderTitle">订单信息</p>
          <div class="orderNubBox">
            <span class="orderNubTitle">预订人名</span>
            <span class="orderNub">{{orderInfo.userName}}</span>
          </div>
          <div class="orderNubBox">
            <span class="orderNubTitle">联系电话</span>
            <span class="orderNub">{{orderInfo.phone}}</span>
          </div>
          <div class="orderNubBox">
            <span class="orderNubTitle">订单编号</span>
            <span class="orderNub_c">{{orderInfo.orderNo}}</span>
            <span class="copy" @click="copyTradeCode" :data-clipboard-text="orderInfo.orderNo">复制</span>
          </div>
          <div class="orderNubBox" v-if="orderInfo.createTime">
            <span class="orderNubTitle">下单时间</span>
            <span class="orderNub">{{orderInfo.createTime}}</span>
          </div>
          <div class="orderNubBox" v-if="orderInfo.payTime && status == 2">
            <span class="orderNubTitle">支付时间</span>
            <span class="orderNub">{{orderInfo.payTime | formatTime(11)}}</span>
          </div>
        </div>

        <div class="orderCard orderCard2">
          <div class="orderNubBox">
            <span class="orderNubTitle">总计时段</span>
            <span class="orderNub">{{orderInfo.minDate}} {{orderInfo.minTime}}-{{orderInfo.maxTime}}</span>
          </div>
          <div class="orderNubBox">
            <span class="orderNubTitle">商品金额</span>
            <span class="orderNub">￥{{orderInfo.goodsPrice | priceFormat}}</span>
          </div>
          <div class="orderNubBox" v-if="orderInfo.exemptPrice">
            <span class="orderNubTitle">免费额度</span>
            <span class="orderNub">-￥{{orderInfo.exemptPrice | priceFormat}}</span>
          </div>
          <div class="orderNubBox" v-if="couponPrice">
            <span class="orderNubTitle">优惠券</span>
            <span class="orderNub">-￥{{couponPrice|priceFormat}}</span>
          </div>
          <div class="orderNubBox" v-if="deductMoney > 0">
            <span class="orderNubTitle">积分抵扣</span>
            <span class="orderNub">-￥{{deductMoney|priceFormat}}</span>
          </div>
          <div class="orderNubBox" v-if="orderInfo.payFacilitiesPrice">
            <span class="orderNubTitle">付费服务</span>
            <span class="orderNub">+￥{{orderInfo.payFacilitiesPrice|priceFormat}}</span>
          </div>
          <!-- <div class="orderNubBox">
            <span class="orderNubTitle">实付金额</span>
            <span class="orderNub">￥{{orderInfo.payAmount|priceFormat}}</span>
          </div> -->
        </div>

        <div class="payAmountBox">
          <span class="label">{{'实付金额'}}</span>
          <span class="payAmount">￥{{orderInfo.payAmount|priceFormat}}</span>
        </div>

        <div class="orderCard" v-if="orderInfo.receiptTitle &&(status == 2 || status == 5) && orderInfo.payAmount != 0  &&!orderInfo.refundTime">
           <p class="orderTitle">开票信息</p>
           <span class="changeReceipt" @click="invoiceApplication">修改</span>
           <div class="orderNubBox">
            <span class="orderNubTitle">名称</span>
            <span class="orderNub">{{orderInfo.receiptTitle}}</span>
          </div>
          <div class="orderNubBox" v-if="orderInfo.ratepayingNumber">
            <span class="orderNubTitle">税号</span>
            <span class="orderNub">{{orderInfo.ratepayingNumber}}</span>
          </div>
        </div>
         <div class="room_AgreementCard" v-if="meetingAgreementList  && meetingAgreementList.length>0">
           <p class="orderTitle">协议模板</p>
           <div class="room_Agreement_box" v-for="(item,index) in  meetingAgreementList" :key="index">
            <div class="room_Agreement_box1" @click="openFile(item.path,item.agreementName)">
               <img class="room_Agreement_icon" src="../../assets/images/icon_file.png" />
               <span class="room_Agreement_span" >{{item.agreementName}}</span>
               <img class="room_Agreement_icon1" src="../../assets/images/icon_indicator_next.png" />
            </div>
            <div class="room_Agreement_line"></div>
          </div>
         </div>


      <div class="btnBox button" v-if="lastPayTime !== '00分00秒' && status == '0'">
        <span class="cancel btn_primary" @click="cancelOrderByOrderId">取消订单</span>
        <span v-if="orderInfo.payType != 6" class="btn btn_default" @click="goPayCenter">立即支付</span>
      </div>


      <div class="btnBox button" v-if="isRefund">
        <!-- <span class="cancel btn_primary" v-if="!orderInfo.receiptTitle && orderInfo.payAmount != 0"  @click="invoiceApplication">开具发票</span> -->
        <span class="btn btn_default"  v-if="orderInfo.payAmount != 0" @click="refund">申请退款</span>
      </div>
       <!-- <div class="btnBox button" v-else-if="status == 2 && orderInfo.payAmount != 0">
        <span class="cancel btn_primary" v-if="!orderInfo.receiptTitle && orderInfo.payAmount != 0"  @click="invoiceApplication">开具发票</span>
      </div> -->

      <div class="btnBox button" v-if="status == 5 && (orderInfo.hasTemp || ((!receiptStatus || receiptStatus==3) && orderInfo.payAmount != 0))">
        <!-- <span class="cancel btn_primary" v-if=" !orderInfo.receiptTitle &&!orderInfo.refundTime && orderInfo.payAmount != 0"  @click="invoiceApplication">开具发票</span> -->
        <span class="btn btn_default" v-if="orderInfo.hasTemp && orderInfo.isEvaluate == 0" @click="evaluate">去评价</span>
        <span class="btn btn_default" v-if="orderInfo.isEvaluate"  @click="viewEvaluation">查看评价</span>
        <!-- <span class="cancel btn_primary" v-if="(!receiptStatus || receiptStatus==3) && orderInfo.payAmount != 0" bindtap="invoiceApplication">申请发票</span> -->
      </div>

      <div class="btnBox button" v-if="status == 2 && orderInfo.payAmount == 0">
        <span class="btn btn_primary" @click="confirm">取消订单</span>
      </div>
  </div>
  </div>
</template>

<script>
import util from '../../utils/util';
import {serversHttp} from '../../utils/api.js';
import { getMeetingOrderDetailById, desEncrypt,cancelMeetingOrder, getOrderRefundRequest, transformToBase64 } from '../../utils/api';
import { mapState } from 'vuex';
import QRCode from 'qrcodejs2';
import Clipboard from 'clipboard';
import ping from '../../utils/pingpay.js'
var timeout = '';
export default {
  name: 'exchangeOrderDetail',
  props: {},
  filters: {
    statusText: function (value) {
        // 1已取消，3作废
      if (value === 0) {
        return '等待付款';
      } else if (value === 1 || value === 3) {
        return '已取消';
      } else if (value === 2) {
        return '已支付';
      } else if(value === 6){
        return '已退订'
      }else{
        return '已结束';
      }
    },
    statusPrompt: function (value) {
      if (value === 1) {
        return '取消原因：用户主动取消';
      } else if (value === 2) {
        return '支付成功，请在预订时间内使用';
      } else if (value === 3) {
        return '取消原因：超时取消';
      } else {
        return '感谢您的使用';
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  unmounted () {
    clearTimeout(timeout);
  },
  data () {
    return {
      //
      receiptStatus: 0,
      couponPrice: 0,
      deductMoney: 0,
      receiptSucTime: null,
      receiptCreateTime: null,
      courierService: '',
      lastPayTime: '',
      isRefund: false,

      title: '活动表单',
      orderNo: '',
      status: '',
      showPage: false,
      doorLockId:false, //是否开通二维吗设备
      orderInfo: {},
      activeReg: '',

      QRCode: '',
      timestamp:'',
      qrcodeTool:'',
      payAmount: '',
      meetingAgreementList:'',
      isAgreement:'',
      refunding:false,//是否在退款中(点击申请退款后设置为true,避免状态跟新不及时显示二维码问题)
      id: ''
    };
  },
  created () {
    // this.id = this.$route.query.id;
    // this.getMeetingOrderDetailById()
  },
  activated () {
    this.id = this.$route.query.id;
    this.getMeetingOrderDetailById()
    // if (this.id !== this.$route.query.id) {
    //   this.id = this.$route.query.id;
    //   this.getMeetingOrderDetailById()
    // }
    // if (this.common.isChange) {
    //   this.$store.commit('isChange', false)
    //   this.getMeetingOrderDetailById()
    // }
  },
  methods: {
    goMeetingDetail(id) {
      this.$router.push(`/roomDetail?id=${id}`)
      },
    // 取消会议室订单
    cancelMeetingOrder() {
      // app.globalData.isChange = true;
      let self = this;
      cancelMeetingOrder({
        "orderNo": this.orderInfo.orderNo
      }).then(res => {
        util.showToast(res.res.msg)
        if (res.res.code == 10000) {
          self.getMeetingOrderDetailById()
        }
      })
    },
    // 使用了免费额度取消订单
    confirm() {
      let self = this;
      if(self.couponPrice > 0 && this.orderInfo.payAmount == 0){
        self.cancelMeetingOrder()
        return;
      }
      util.showModal('温馨提示','已使用的免额暂不支持退还，请确认操作',true,'确定',
       function(){
          self.cancelMeetingOrder()
      })

      // app.globalData.isChange = true;
    },
    viewEvaluation () {
      this.$router.push(`/evaluate/viewEvaluate?id=${this.orderInfo.id}`)
    },
    evaluate () {
      this.$router.push(`/evaluate/evaluate?id=${this.orderInfo.id}&referenceName=${this.orderInfo.meetingRoomName}&templateType=3&referenceNo=${this.orderInfo.orderNo}`)
    },
    goActivityDetail (id) {
       // this.$router.push(`/activityDetails/${id}`)
        var url = `/activityDetails/${id}`;
        if(this.common.cityId){
          url =url +"?cityId="+this.common.cityId
        }else if(this.common.marketInfo.id){
          url =url +"?marketId="+this.common.marketInfo.id
        }
        this.$router.push(url);
    },
    copyTradeCode () {
      var clipboard = new Clipboard('.copy')
      clipboard.on('success', e => {
        util.showToast('复制成功')
          // 释放内存
        clipboard.destroy()
      })
    },
    // 立即支付
    goPayCenter () {
      let params = {
        orderNo: this.orderInfo.orderNo,
        repairNo: '', // "报修单号",
        bussinessType:"1",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6
        feeCode:"",
        // payType: '5', // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"
        channel: 'wx_pub' // 渠道名
      };
      let header = {
        openId: this.common.openId
      };
      ping(
        params,
        header,
        res => {
          console.log(res);
          this.getMeetingOrderDetailById()
        },
        () => {
          this.getMeetingOrderDetailById()
        },
        () => {
          this.getMeetingOrderDetailById()
        }
      );
    },
    goDetail () {
      this.$router.push(`/mall/goodsDetail/${this.details.activeId}`)
    },
    getMeetingOrderDetailById () {
      getMeetingOrderDetailById({orderNo: this.id}).then(res => {
        console.log(res)
        if (!res.res) {
          util.showToast('服务异常');
          return;
        }
        if (res.res.code === 10000 && res.body) {
          this.timestamp =res.res.timestamp;
          this.meetingAgreementList =res.body.meetingAgreementList;
          this.isAgreement = res.body.order.isAgreement;
          if(res.body.order.refundUpdTime){
            res.body.order.refundUpdTime = util.formatTime(new Date(res.body.order.refundUpdTime),8)
          }
          if(res.body.order.refundTime){
            res.body.order.refundTime = util.formatTime(new Date(res.body.order.refundTime),8)
          }
          if(res.body.order.refundSucTime){
            res.body.order.refundSucTime = util.formatTime(new Date(res.body.order.refundSucTime),8)
          }
          if(res.body.order.createTime){
            res.body.order.createTime = util.formatTime(new Date(res.body.order.createTime),9)
          }

          let date = util.formatTime(new Date(res.body.order.lastPayTime - Date.parse(new Date())), 3)

          if (res.body.order) {
            this.orderInfo = res.body.order;
            this.status = res.body.order.status;
            this.doorLockId = res.body.doorLockId;
            this.isRefund = res.body.isRefund;
            this.receiptStatus = res.body.receiptStatus;
            this.deductMoney = res.body.order.deductMoney || 0;
          } else {
            util.showToast('暂无数据');
          }

          if (res.body.receiptCreateTime) {
              this.receiptCreateTime = util.formatTime(new Date(res.body.receiptCreateTime),8)
          }
          if (res.body.receiptSucTime) {
              this.receiptSucTime = util.formatTime(new Date(res.body.receiptSucTime),8)
          }

          // 快递公司
          if (res.body.courierService) {
              this.courierService = res.body.courierService
          }
          // 快递单号
          if (res.body.courierNumber) {
              this.courierService = res.body.courierNumber
          }

          if (this.orderInfo.exemptPrice) {
              this.couponPrice = util.accSubtr(util.accSubtr(util.accSubtr(this.orderInfo.totalPrice, this.orderInfo.payAmount), this.orderInfo.exemptPrice),this.deductMoney)
          } else {
              this.couponPrice = util.accSubtr(util.accSubtr(this.orderInfo.totalPrice, this.orderInfo.payAmount),this.deductMoney)
          }

          if (this.status === 0) {
            this.leftTimer(date)
          } else if ((this.status === 2 || this.status === 5) && !this.refunding && !(this.orderInfo.refundStatus || this.orderInfo.refundStatus === 0)) {
            //this.getQRCode()
           // this.getTenantQrCode();
            this.getTenantQrCode();
          }
        } else {
          util.showToast(res.res.msg);
        }
        this.showPage = true;
      })
    },
    leftTimer (leftTime) {
      clearTimeout(timeout)
      var minutes = parseInt(leftTime / 60 % 60, 10); // 计算剩余的分钟
      var seconds = parseInt(leftTime % 60, 10); // 计算剩余的秒数
      var myTime = leftTime
      minutes = this.checkTime(minutes);
      seconds = this.checkTime(seconds);
      if (myTime >= 0) {
        this.lastPayTime = minutes + '分' + seconds + '秒';
        myTime = myTime - 1
        timeout = setTimeout(() => {
          this.leftTimer(myTime)
        }, 1000)
      }
    },
    checkTime (i) { // 将0-9的数字前面加上0，例1变为01
      if (i < 10) {
        i = '0' + i;
      }
      return i;
    },
    // 取消订单
    cancelOrderByOrderId () {
      let self =  this;
      util.showModal('', '确定要取消该订单吗？', true,'确定',() => {
        cancelMeetingOrder({
          orderNo: this.orderInfo.orderNo,
        }).then(res => {
          util.showToast(res.res.msg)
          if (res.res.code === 10000) {
            self.getMeetingOrderDetailById()
          }
        })
      }, () => {
      })
    },
    // 退款
    refund(){
      let self = this;
      util.showModal('', '确定要退款吗？', true,'确定',() => {
        getOrderRefundRequest({
          orderNo:self.orderInfo.orderNo
        }).then(res => {
          util.showToast(res.res.msg)
          if(res.res.code === 10000){
            self.refunding = true;
            self.getMeetingOrderDetailById()
          }
        })
      }, () => {
      })
    },
    //获取二维码数据
    getTenantQrCode() {
      let content = {
          uid: this.orderInfo.id,
          operationType: "3", //1门禁,2访客，3.会议室
          userId: this.orderInfo.userId,
          marketId: this.common.marketInfo.id,
          timestamp: this.timestamp.toString(),
          // actId: this.orderInfo.actId,
          // orderNo: this.orderInfo.orderNo,
          // orderType: '1'
      };
      desEncrypt(content).then(res => {
        console.log("获取门禁数据："+JSON.stringify(res))
        this.pageShow = true;
        this.hasData = true;
        // let content_m = {
        //       uid: res.uid,
        //       operationType: res.operationType,
        //       userId: res.userId,
        //       marketId:res.marketId,
        //       timestamp: res.timestamp,
        //       // actId: res.actId,
        //       // orderNo: res.orderNo,
        //       // orderType: res.orderType
        //     };
        this.creatQrCode(res);
      })
    },
    //js生成二维码
    creatQrCode(dic) {
      //{qrcode:code}  ;
      if(!this.qrcodeTool){
        var wh =document.body.clientWidth;
        var w =170*wh/375;
        var h =170*wh/375;
        this.qrcodeTool = new QRCode(this.$refs.qrCodeUrl, {
          text: dic ,
          //JSON.stringify(map).replace(/(\")/g,"\\$1"),
          width: w,
          height: h,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.M
        })
      }else{
        this.qrcodeTool.clear(); // 清除代码
        this.qrcodeTool.makeCode(dic); // 生成另外一个二维码
      }
    },
    getQRCode: function () {
      let content = {
        actId: this.orderInfo.actId,
        orderNo: this.orderInfo.orderNo,
        userId: this.orderInfo.userId,
        orderType: '1'
      }
      transformToBase64(content,'meeting').then(res => {
        if (res.res.code === 10000) {
          this.QRCode = res.body['encodeBase64']
        }
      });
    },
    // 去开票
    invoiceApplication(){
      var urlStr = `/invoiceFrom?id=${this.orderInfo.orderNo}`
      if(this.orderInfo.receiptTitle){
         urlStr = urlStr +"&receiptTitle=" +this.orderInfo.receiptTitle +"&receiptType="+this.orderInfo.receiptType
         if(this.orderInfo.ratepayingNumber ){
           urlStr =urlStr +"&ratepayingNumber=" + this.orderInfo.ratepayingNumber;
         }

      }
      this.$router.push(urlStr)
    },
     openFile(file ,fileName){
      if(fileName.indexOf('png') > -1|| fileName.indexOf('jpg') > -1||fileName.indexOf('jpeg') > -1  ||fileName.indexOf('gif') > -1 ||fileName.indexOf('tif') > -1){
         localStorage.setItem("src", file);
         // 跳转地址
         this.$router.push(`/yuelanImage`);
        return;
      }
       if(fileName.indexOf('pdf') > -1){
            var url =serversHttp+ "servers.api/systemApi/exportFile?url="+encodeURIComponent(file)
            console.log(url);
            localStorage.setItem("src", url);
            localStorage.setItem("srcFlie", file);
          // 跳转地址
            var openUrl ='/yulanpdf?meetingRoomId='+this.orderInfo.meetingRoomId+"&isAgreement="+this.isAgreement +"&agreementName="+fileName
            this.$router.push(openUrl);
            return
        }
          // 微信中无法打开
          // var url1 ="https://view.officeapps.live.com/op/view.aspx?src="+encodeURIComponent(file)
           var url1 ='http://view.xdocin.com/xdoc?_xdoc='+encodeURIComponent(file)
           console.log(url1);
           localStorage.setItem("src",url1);
           localStorage.setItem("srcFlie", file);
           var openUrl ='/iframePage?meetingRoomId='+this.orderInfo.meetingRoomId+"&isAgreement="+this.isAgreement +"&agreementName="+fileName
           this.$router.push(openUrl)

    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.wrapper {
    background-color: #eee;
  }
  .wrapper_main{
    margin-bottom:120px;
  }
  .headerBox {
    height: 152px;
    .commonBg();
    .flex();
    justify-content: space-between;
    align-items: center;
    padding: 28px;
    position: relative;
    background:linear-gradient(90deg,rgba(23,64,218,1) 0%,rgba(101,0,255,1) 100%);
    .order_img{
      position:absolute;
      right:38px;bottom:16px;width:144px;
      height:114px;
      z-index:2;
    }
  }
  .cardLeft {
    .flex(column);
    justify-content: space-between;
    align-items: flex-start;
    height: 96px;
  }

  .clockBox {
    .flex();
    align-items: center;
    height: 36px;
  }

  .clockIcon {
    width: 36px;
    height: 36px;
    margin-right: 14px;
  }

  .clockText {
    .fontSize(14px);
    font-weight: bold;
    color: #fff;
  }

  .statusText {
    height: 36px;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    .fontSize(11px);
    color: rgba(255, 255, 255, 1);
    line-height: 36px;
    text-align: center;
    padding: 0 14px;
  }
  /*item 样式*/
  .click_item{
    display:flex;
    flex-direction: row;
    padding: 28px;
    opacity: 1;
    background-color: #ffffff;
    margin-bottom:14px;
  }
  .click_item:active{
    opacity: 0.7;
  }
  .click_image{
    display: block;
    width: 240px;
    height: 180px;
    margin-right: 20px;
  }
  .click_info{
    .flex(column);
    flex:1;
  }
  .click_title{
    height:40px;
    .fontSize(14px);
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:40px;
    .textOver(434px);
    margin-bottom: 14px;
  }
  .click_desc{
    .fontSize(12px);
    color:@color6;
    line-height:34px;
    margin-bottom: 8px;
    .textOver(434px);
  }
  .click_time{
    color:@color9;
    white-space: nowrap;
  }
  .click_address{
    line-height:34px;
    max-height:68px;
    overflow:hidden;
    width:434px;
    color:@color9;
    .fontSize(12px);
  }
  .ellipsis{
    overflow:hidden;
    text-overflow:ellipsis;
  }

  /*-----------中间卡片信息模块------*/

  .card_box {
    position: relative;
    width: 690px;
    margin-left: 30px;
    margin-top: 26px;
  }

  .card_title {
    .fontSize(14px);
    font-weight: bold;
    color: rgba(254, 254, 254, 1);
    line-height: 36px;
    position: absolute;
    left: 28px;
    top: 30px;
    right: 28px;
  }

  .pay_time {
    .fontSize(12px);
    color: rgba(254, 254, 254, 1);
  }

  .card_address {
    .fontSize(12px);
    color: rgba(254, 254, 254, 1);
    position: absolute;
    left: 28px;
    top: 116px;
    right: 28px;
  }

  .card_price_box {
    flex-direction: row;
    position: absolute;
    left: 28px;
    right: 28px;
    bottom: 124px;
  }

  .card_price {
    color: #FFF;
    .fontSize(18px);
    line-height: 36px;
  }

  .card_num {
    color: #FFF;
    .fontSize(12px);
    line-height: 36px;
    margin-top: 4px;
  }

  .card_time_box {
    flex-direction: row;
    justify-content: space-between;
    position: absolute;
    height: 102px;
    align-items: center;
    left: 28px;
    right: 28px;
    bottom: 0;
  }

  .activity_time {
    color: #FFF;
    .fontSize(12px);
  }

  /*----------中间用户信息模块-------*/
  .refundBox {
    background-color: rgba(255, 255, 255, 1);
    padding: 28px;
  }

  .refundText {
    height:44px;
    .fontSize(16px);
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 44px;
    margin-bottom: 20px;
    padding-left: 18px;
    position: relative;
    &::after{
      position: absolute;
      content:'';
      left:0;top:4px;
      width:6px;
      height:24px;
      background:@color17;
    }
  }

  .refundMainBox {
    .flex();
    margin-top: 18px;
    width:710px;
  }

  .refundMainLeft {
    width: 72px;
    .flex(column);
    justify-content: space-around;
    align-items: center;
  }

  .refundMainRight {
    flex: 1;
    height:34px;
    .flex(column);
    justify-content: space-between;
  }
  .refundMainRight_upt{
    height:128px;
  }
  .refundMainRight_succ{
    height:220px;
  }

  .refundMainText {
    .fontSize(12px);
    /*color: rgba(51, 51, 51, 1);*/
    line-height: 34px;
  }
  .refund_active{
    color: #333333;
  }
  .refund_default{
    color: #DADADA;
  }

  .circle {
    width: 20px;
    height: 20px;
    background-color: @color17;
    border: 4px solid rgba(255, 255, 255, 1);
    border-radius: 100%;
    // margin: 7px 0;
  }

  .upright {
    width: 4px;
    height: 60px;
    /*background-color: @color17;*/
  }
  .active_color {
    background-color: @color17;
  }
  .default_color {
    background-color: #DADADA;
  }

  /*----------中间用户信息模块-------*/

  .copy {
    width: 96px;
    height: 40px;
    border-radius: 4px;
    .border();
    .fontSize(12px);
    color: @color3;
    line-height: 40px;
    text-align: center;
    margin-left: 28px;
  }

  .mainCard {
    width: 100%;
    background-color: rgba(255, 255, 255, 1);
    /*box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.02);*/
    /*border-radius: 16px;*/
    margin-bottom: 14px;
    overflow:hidden;
  }

 .QRCodeCard {
    .flex(column);
    align-items: center;
    width: 100%;
  }
  .QRCodeTitle {
    .fontSize(18px);
    font-weight:bold;
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
    margin-top: 60px;
  }

  .QRCode {
    margin-top: 40px;
    padding-bottom: 10px;
    width: 340px;
    height: 340px;
    /*margin: 20px 0;*/
  }

  .QRCodeOrderNo {
    .fontSize(14px);
    margin-top: 10px;
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
    margin-bottom: 40px;
  }
  .QRCode_tips_div{
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 28px;
    width:710px;
    height:112px;
    background:rgba(244,244,244,1);
    border-radius:8px;
    flex-direction: row;
    display: flex;

  }
  .QRCode_tips_icon{
    margin-top: 20px;
    margin-left: 20px;
    width: 28px;
    height: 28px;

  }
  .QRCode_tips_span{
    margin-top: 20px;
    margin-left: 20px;
    width:622px;
    height:72px;
    font-size:26px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:36px;

  }

  .orderCard {
    padding: 28px;
    margin: 14px 0;
    background-color: #ffffff;
    position: relative;
  }
  .room_AgreementCard{
     padding-left: 28px;
     padding-top: 28px;
     padding-right: 28px;
     margin: 14px 0;
     background-color: #ffffff;
     position: relative;
  }
  .orderCard2{
    margin: 14px 0 0;
  }
  .changeReceipt{
    position: absolute;
    top:28px;
    right: 28px;
    height:44px;
    .fontSize(14px);
    color:#1740DA;
    line-height:44px;
  }

  .createTimeBox {
    border-top: 2px solid rgba(234, 234, 234, 1);
    padding: 0 20px 28px;
  }

  .orderTitle {
    height: 28px;
    .fontSize(14px);
    font-weight: bold;
    color: @color3;
    line-height: 28px;
    border-left:4px solid @color17;
    margin-top: 6px;
    margin-bottom: 20px;
    padding-left: 14px;
  }

  .orderNubBox {
    min-height: 40px;
    margin-bottom: 14px;
    .flex();
  }

  .orderNubTitle {
    .fontSize(12px);
    color: @color6;
    line-height:34px;
    padding-left: 16px;
    width: 150px;
  }

  .orderNub {
    .fontSize(12px);
    color: @color3;
    line-height:34px;
    width:500px;
  }
  .orderNub_c{
    .fontSize(12px);
    color: rgba(51, 51, 51, 1);
    line-height:40px;
  }

  .customer_box {
    padding-top: 20px;
    border-bottom:10px solid #f3f4f6;
  }

  .customer_box_list {
    flex-direction: row;
    justify-content: space-between;
    .borderT();
    padding-left: 30px;
    padding-right: 30px;
  }

  .list_key {
    height: 100px;
    line-height: 100px;
    .fontSize(14px);
    color: #999;
  }

  .list_val {
    height: 100px;
    line-height: 100px;
    .fontSize(14px);
    color: #333;
  }

  /*----------中间支付选择模块-------*/


  .butn_img {
    position: relative;
    top: -1px;
    left: -1px;
  }

  .payAmountBox {
    background-color: #fff;
    height: 92px;
    line-height: 92px;

    .flex();
    align-items: center;
    justify-content: space-between;
    padding: 0 44px;
    margin: 0px 0 14px;
    border-top: 1px solid rgba(234, 234, 234, 1);
    /*border-radius: 16px;*/
  }

  .label {
    .fontSize(13px);
    color: rgba(51, 51, 51, 1);
  }

  .payAmount {
    .fontSize(13px);
    color: rgba(252, 63, 86, 1);
  }
  //协议
  .room_Agreement_box{
  width:100%;
  height:100px;
  flex-direction: column;
  display: flex;
}
.room_Agreement_box1{
  width:100%;
  height:98px;
  flex-direction: row;
  align-items: center;
  display: flex;
}

.room_Agreement_icon{
  width: 40px;
  height: 40px;
  // s

}
.room_Agreement_span{
  margin-left: 14px;
  margin-right: 8px;
  display: flex;
  width:610px;
  height:40px;
  font-size:28px;
  font-weight:400;
  color:rgba(60,100,159,1);
  line-height:40px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
     white-space: pre-line;
}
.room_Agreement_icon1{
  width: 32px;
  height: 32px;
}
.room_Agreement_line{
  // margin-left: 28px;
  width:722px;
  height:2px;
  background:rgba(234,234,234,1);
}

  /*-----------底部模块----------*/

  .btnBox {
    height: 108px;
    position:fixed;
    bottom:0;left:0;right:0;
    z-index:33;
    .borderT();
    background-color: #fff;
    .flex();
    align-items: center;
    justify-content: flex-end;
  }

  .cancel {
    width: 152px;
    height: 56px;
    box-sizing: border-box;
    border-radius: 4px;
    .border();
    .fontSize(13px);
    color: rgba(102, 102, 102, 1);
    line-height: 56px;
    text-align: center;
    margin-right: 20px;
  }


.btn {
  width: 152px;
  height: 56px;
  border-radius: 4px;
  .border(@color17);
  .fontSize(13px);
  color:@color17;
  line-height: 56px;
  text-align: center;
  margin-right: 28px;
}
.QRCodeOrderNo_tips{
  margin-top: 14px;
  width:100%;
  height:36px;
  // background:rgba(255,229,210,1);
  text-align: center;
  line-height: 36px;
  font-size:26px;
  color:rgba(255,126,30,1);
}
/* 开门密码 */
.password_text{
height:40px;
font-size:28px;
color:rgba(51,51,51,1);
line-height:40px;
display: block;
text-align:center;
margin:40px 0 28px;
}
.password_main{
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom:60px;
}
.password_item{
  display:block;
  width:52px;height:76px;
  background:rgba(248,248,248,1);
  border-radius:8px;
  border:1px solid rgba(234,234,234,1);
  text-align:center;
  line-height:76px;
  margin:0 14px;
  font-size:60px;font-weight: bold;
color:rgba(51,51,51,1);
}
</style>
